const resources = {
  "en": {
    "deadlines": {
      "title": "Manage Deadlines",
      "description": "Organize reminders by priority and due date to stay ahead of commitments.",
      "add": "Add deadline",
      "reorder": "Reorder",
      "done": "Done",
      "cardTitle": "Deadlines",
      "cardDescription": "Track what is due next, adjust the sequence when priorities shift, and keep upcoming commitments visible.",
      "created": "✅ Deadline created",
      "updated": "✅ Deadline updated",
      "deleted": "✅ Deadline deleted",
      "loadFailed": "❌ Failed to load deadlines",
      "orderSaved": "✅ Order saved",
      "orderSaveFailed": "❌ Failed to save order",
      "saveOrder": "Save order",
      "reorderHintTitle": "Reorder without drag & drop",
      "reorderHintDescription": "On compact screens, tap \"Reorder\" to reveal move buttons. On larger screens, you can drag deadlines directly.",
      "reorderHintActiveDescription": "Use the move buttons to position deadlines. Nothing is sent to the server until you save the order.",
      "reorderHintPendingDescription": "Move buttons update the preview immediately. Tap \"Save order\" to keep the new sequence.",
      "moveUp": "Move deadline up",
      "moveDown": "Move deadline down",
      "none": "No deadlines yet",
      "emptyTitle": "No deadlines to track",
      "emptyDescription": "Create your first reminder so recurring bills and goals stay visible.",
      "emptyCta": "Create a deadline",
      "saveFailed": "Failed to save deadline",
      "dueDateUnset": "No due date",
      "confirmDelete": "Delete this deadline?",
      "confirmDeleteOk": "Yes, delete",
      "confirmDeleteCancel": "Cancel",
      "modal": {
        "addTitle": "Add Deadline",
        "editTitle": "Edit Deadline",
        "save": "Save",
        "titleLabel": "Title",
        "titleRequired": "Title is required",
        "detailsLabel": "Details",
        "detailsPlaceholder": "Optional description",
        "dueDateLabel": "Due date",
        "priorityLabel": "Priority",
        "priorityHigh": "High",
        "priorityNormal": "Normal",
        "priorityLow": "Low"
      }
    }
  },
  "uk": {
    "deadlines": {
      "title": "Керування дедлайнами",
      "description": "Упорядковуйте нагадування за пріоритетом і датою, щоб нічого не пропустити.",
      "add": "Додати дедлайн",
      "reorder": "Змінити порядок",
      "done": "Готово",
      "cardTitle": "Дедлайни",
      "cardDescription": "Стежте за найближчими дедлайнами, змінюйте послідовність коли пріоритети зсуваються й тримайте зобов’язання на видноті.",
      "created": "✅ Дедлайн створено",
      "updated": "✅ Дедлайн оновлено",
      "deleted": "✅ Дедлайн видалено",
      "loadFailed": "❌ Не вдалося завантажити дедлайни",
      "orderSaved": "✅ Порядок збережено",
      "orderSaveFailed": "❌ Не вдалося зберегти порядок",
      "saveOrder": "Зберегти порядок",
      "reorderHintTitle": "Змінюйте порядок без перетягування",
      "reorderHintDescription": "На компактних екранах натисніть «Змінити порядок», щоб побачити кнопки переміщення. На ширших екранах дедлайни можна перетягувати.",
      "reorderHintActiveDescription": "Використовуйте кнопки переміщення, щоб розставити дедлайни. На сервер нічого не надсилається, доки ви не збережете порядок.",
      "reorderHintPendingDescription": "Кнопки переміщення одразу оновлюють превʼю. Натисніть «Зберегти порядок», щоб закріпити нову послідовність.",
      "moveUp": "Перемістити дедлайн вище",
      "moveDown": "Перемістити дедлайн нижче",
      "none": "Поки без дедлайнів",
      "emptyTitle": "Дедлайни ще не створені",
      "emptyDescription": "Додайте перше нагадування, щоб рахунки та цілі не губилися.",
      "emptyCta": "Створити дедлайн",
      "saveFailed": "Не вдалося зберегти дедлайн",
      "dueDateUnset": "Без дати",
      "confirmDelete": "Видалити цей дедлайн?",
      "confirmDeleteOk": "Так, видалити",
      "confirmDeleteCancel": "Скасувати",
      "modal": {
        "addTitle": "Додати дедлайн",
        "editTitle": "Редагувати дедлайн",
        "save": "Зберегти",
        "titleLabel": "Назва",
        "titleRequired": "Вкажіть назву",
        "detailsLabel": "Деталі",
        "detailsPlaceholder": "Необов’язковий опис",
        "dueDateLabel": "Крайній термін",
        "priorityLabel": "Пріоритет",
        "priorityHigh": "Високий",
        "priorityNormal": "Звичайний",
        "priorityLow": "Низький"
      }
    }
  }
};

export default resources;
